// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';
import Link from 'next/link';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';

export const ProductTitleBrand = Styled(Link)`
  height: 62px;
  text-decoration: none;
`;
export const ProductBrand = Styled.span`
  font-family: Nunito;
  font-size: 12px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${(props) => props.theme.colors.TEXT.BRANDGRAY};
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 10px;
  }
`;
export const ProductTitle = Styled.span`
  font-family: Nunito;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: normal;
  ${(props) => (!props.isTileRedesignAB || props.isPjpTile) && `min-height:  ${props.mh || 38}px;`}

  text-align: left;
  color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    font-size: 13px;
    ${(props) =>
      (!props.isTileRedesignAB || props.isPjpTile) && `min-height:  ${props.mh || 35}px;`}
  }
  @media ${(props) => props.theme.mediaQuery.small} {
    white-space: break-spaces;
  }
`;

export const AltPlpProductBrand = Styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  min-height:  ${(props) => props.mh || 36}px;
  color: ${(props) => props.theme.colors.ANCHOR.PRIMARY};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top:24px;
  font-family: WorkSans;
`;

export const AltPlpProductTitle = Styled.span`
  height: 43px;
  font-weight: 600;
  font-size: 18px;
  line-height: 21px;
  display: flex;
  color: #000000;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 1;

  letter-spacing: 0em;
  text-align: left;
  min-height:  ${(props) => props.mh || 36}px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top:8px;
  font-family: WorkSans;
`;

export const ExtendedSizes = Styled(BodyCopy)`
  margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS} 0;
  height: ${(props) => props.theme.spacing.ELEM_SPACING.REG};
  text-transform: uppercase;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  @media ${(props) => props.theme.mediaQuery.large} {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.XXS} 0;
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
`;
